import React from 'react';
import styled from 'styled-components';

type CalloutVariant = 'info' | 'warning' | 'tip';

const COLORS: Record<CalloutVariant, { bg: string; border: string; label: string }> = {
    info: { bg: '#eff6ff', border: '#bfdbfe', label: '#1d4ed8' },
    warning: { bg: '#fffbeb', border: '#fde68a', label: '#b45309' },
    tip: { bg: '#f0fdf4', border: '#bbf7d0', label: '#15803d' },
};

const LABELS: Record<CalloutVariant, string> = {
    info: 'Note',
    warning: 'Watch out',
    tip: 'Tip',
};

const Box = styled.div<{ variant: CalloutVariant }>`
    width: 100%;
    background: ${({ variant }) => COLORS[variant].bg};
    border-left: 3px solid ${({ variant }) => COLORS[variant].border};
    border-radius: 0 8px 8px 0;
    padding: 14px 18px;
    margin: 0 0 16px;
`;

const Label = styled.span<{ variant: CalloutVariant }>`
    display: block;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${({ variant }) => COLORS[variant].label};
    margin-bottom: 4px;
`;

const Text = styled.p`
    font-size: 15px;
    line-height: 24px;
    color: #374151;
    margin: 0;
`;

interface CalloutProps {
    variant?: CalloutVariant;
    label?: string;
    children: React.ReactNode;
}

const Callout: React.FC<CalloutProps> = ({ variant = 'info', label, children }) => (
    <Box variant={variant}>
        <Label variant={variant}>{label ?? LABELS[variant]}</Label>
        <Text>{children}</Text>
    </Box>
);

export default Callout;
